module.exports = __webpack_public_path__ + "img/es-13.2cd5b594.svg";